module.exports = __webpack_public_path__ + "img/products3.66ef3264.jpg";